export const CONFIRM_MODAL_ID = 'confirm-modal';
